import { map } from 'rxjs/operators';
import { API_URL } from 'consts/common.const';
import { Http, Response } from 'services/http';

interface UserSpecialRes {
  user_id: number;
  emp_name: string;
}

interface UserItem {
  label: string;
  value: number;
}

export type UserSpecialParam = 'sale' | 'recer' | 'am' | 'userCv' | 'allUser';

export const getUserSpecial = (data: UserSpecialParam) => {
  return Http.request({
    method: 'GET',
    url: `${API_URL}/common/pulldown/${data}`,
  }).pipe(
    map((res: Response<UserSpecialRes[]>) => {
      const newData: UserItem[] = res.data.map((item) => ({
        label: item.emp_name,
        value: item.user_id,
      }));

      return newData;
    })
  );
};
